// ============================================================================
// HINDI TRANSLATIONS - CHAPTER 1: उत्पत्ति
// ============================================================================
// स्तर 1-13 (13 स्तर, 39 प्रश्न)

export const chapter1Translations = {
  name: "उत्पत्ति",
  description: "आदि में... ज्ञान आत्मा को जीवित करता है",
  
  spiritualWisdom: {
    principle: "ज्ञान आत्मा को जीवित करता है",
    scripture: "मेरे लोग ज्ञान के बिना नष्ट हो रहे हैं (होशे 4:6)",
    application: "प्रत्येक अध्ययन किया गया पद, प्रत्येक खोजी गई सच्चाई हमारी आत्मा को पोषण देती है और हमारे विश्वास को मजबूत करती है"
  },
  
  levels: {
    1: {
      name: "सृष्टि",
      challenge: "आदि में परमेश्वर ने आकाश और पृथ्वी की सृष्टि की...",
      easy: {
        question: "परमेश्वर ने कितने दिनों में संसार की रचना की?",
        options: ["5 दिन", "6 दिन", "7 दिन", "8 दिन"],
        hint: "सप्ताह में विश्राम के दिन के बारे में सोचें",
        funFact: "💡 7वें दिन परमेश्वर ने विश्राम किया। यही सब्त का आधार है, हर सप्ताह का विश्राम दिवस!"
      },
      medium: {
        question: "परमेश्वर ने चौथे दिन क्या बनाया?",
        options: ["जानवर", "मनुष्य", "सूरज, चाँद और तारे", "पौधे"],
        hint: "ये चीजें दुनिया को रोशन करती हैं और समय दिखाती हैं",
        funFact: "🌟 ज्योतियाँ ऋतुओं और धार्मिक पर्वों को चिह्नित करने के लिए बनाई गई थीं!"
      },
      hard: {
        question: "'परमेश्वर की छवि में' बनाए जाने का क्या अर्थ है?",
        options: [
          "समान भौतिक स्वरूप",
          "सृजन और प्रेम करने की क्षमता",
          "स्वाभाविक अनन्त जीवन",
          "दिव्य शक्तियाँ"
        ],
        hint: "यह आध्यात्मिक और बौद्धिक गुणों के बारे में है",
        funFact: "✨ हमारे भीतर परमेश्वर की छवि में रचनात्मकता, विवेक और प्रेम करने की क्षमता शामिल है!"
      }
    },
    
    2: {
      name: "बगीचे में प्रलोभन",
      challenge: "साँप सभी जानवरों में सबसे चालाक था...",
      easy: {
        question: "बगीचे में किस जानवर ने हव्वा को प्रलोभित किया?",
        options: ["शेर", "साँप", "चील", "अजगर"],
        hint: "यह जानवर पेट के बल रेंगता है",
        funFact: "🐍 साँप पूरे बाइबल में परीक्षा और चालाकी का प्रतिनिधित्व करता है!"
      },
      medium: {
        question: "साँप ने हव्वा से क्या झूठा वादा किया?",
        options: [
          "तुम अमर हो जाओगे",
          "तुम अमीर हो जाओगे",
          "तुम परमेश्वर के समान हो जाओगे",
          "तुम खुश रहोगे"
        ],
        hint: "साँप दैवीय स्तर तक उठने का वादा करता है",
        funFact: "🎭 साँप का झूठ सच्चाई और धोखे को मिलाता है - परीक्षा की एक सामान्य रणनीति!"
      },
      hard: {
        question: "यह पतन भले और बुरे के बीच हमारे संघर्ष को कैसे बताता है?",
        options: [
          "बुराई अधिक शक्तिशाली है",
          "स्वतंत्र इच्छा का अर्थ है जिम्मेदारी",
          "परमेश्वर हमें छोड़ देता है",
          "प्रलोभन अजेय हैं"
        ],
        hint: "यह चुनने और परिणाम स्वीकार करने की हमारी क्षमता के बारे में है",
        funFact: "🌳 ज्ञान का वृक्ष नैतिक चुनाव का प्रतीक है जो मानवता को परिभाषित करता है!"
      }
    },
    
    3: {
      name: "कैन और हाबिल",
      challenge: "दो भाई, दो बलिदान, एक शाश्वत चेतावनी...",
      easy: {
        question: "बाइबल के इतिहास में पहला हत्यारा कौन था?",
        options: ["हाबिल", "शेत", "कैन", "आदम"],
        hint: "हाबिल का ईर्ष्यालु भाई",
        funFact: "⚡ कैन विनाशकारी भाईचारे की ईर्ष्या का प्रतीक बन जाता है!"
      },
      medium: {
        question: "परमेश्वर ने हाबिल के बलिदान को क्यों पसंद किया?",
        options: [
          "अधिक मात्रा",
          "हाबिल बेहतर था",
          "यह सच्चे दिल से दिया गया था",
          "यह मांस था"
        ],
        hint: "परमेश्वर हृदय को देखता है",
        funFact: "❤️ परमेश्वर हृदय को देखता है, न कि केवल हमारे कार्यों की बाहरी दिखावट!"
      },
      hard: {
        question: "यह कहानी ईर्ष्या के बारे में क्या सिखाती है?",
        options: [
          "ईर्ष्या स्वाभाविक है",
          "अनियंत्रित ईर्ष्या विनाश की ओर ले जाती है",
          "परमेश्वर दूसरों को पसंद करता है",
          "प्रतिस्पर्धा अच्छी है"
        ],
        hint: "यह हमारी भावनाओं को नियंत्रित न करने के परिणामों के बारे में है",
        funFact: "🔥 'पाप द्वार पर है' - परमेश्वर पतन से पहले चेतावनी देता है!"
      }
    },

    4: {
      name: "नूह की बाढ़",
      challenge: "चालीस दिन और चालीस रात पृथ्वी पर वर्षा होती रही...",
      easy: {
        question: "बाढ़ की बारिश कितने दिन और रात जारी रही?",
        options: ["30 दिन", "40 दिन", "50 दिन", "100 दिन"],
        hint: "बाइबल में एक प्रतीकात्मक संख्या",
        funFact: "☔ संख्या 40 बाइबल में परीक्षण और परिवर्तन का प्रतीक है!"
      },
      medium: {
        question: "नूह को जहाज में शुद्ध पशुओं के कितने जोड़े लेने थे?",
        options: [
          "1 जोड़ा",
          "2 जोड़े",
          "7 जोड़े",
          "10 जोड़े"
        ],
        hint: "अशुद्ध पशुओं से अधिक",
        funFact: "🦁 शुद्ध पशु बाढ़ के बाद बलिदान के लिए थे!"
      },
      hard: {
        question: "जहाज हमारी आध्यात्मिक यात्रा में क्या प्रतीक है?",
        options: [
          "समस्याओं से पलायन",
          "विश्वास और आज्ञाकारिता द्वारा उद्धार",
          "पृथक्करण आवश्यक है",
          "विश्वासियों की श्रेष्ठता"
        ],
        hint: "यह विश्वास करने वालों को दी गई मुक्ति के बारे में है",
        funFact: "🚢 जहाज उद्धार का पूर्वाभास है: न्याय से बचने का एक तरीका!"
      }
    },

    5: {
      name: "बाबेल का गुम्मट",
      challenge: "आओ, हम एक गुम्मट बनाएं जिसकी चोटी आकाश तक पहुंचे...",
      easy: {
        question: "परमेश्वर ने बाबेल में क्या गड़बड़ किया?",
        options: ["योजनाएं", "भाषाएं", "उपकरण", "विचार"],
        hint: "जो संचार की अनुमति देता है",
        funFact: "🗣️ बाबेल दुनिया में भाषाओं की विविधता की उत्पत्ति कथा है!"
      },
      medium: {
        question: "लोग यह गुम्मट क्यों बनाना चाहते थे?",
        options: [
          "अपनी रक्षा करने के लिए",
          "एक साथ रहने के लिए",
          "अपने लिए नाम बनाने और स्वर्ग तक पहुंचने के लिए",
          "परमेश्वर का सम्मान करने के लिए"
        ],
        hint: "यह अहंकार और परमेश्वर के समान बनने की इच्छा के बारे में है",
        funFact: "🏗️ परमेश्वर के समान बनने का अहंकार हमेशा भ्रम की ओर ले जाता है!"
      },
      hard: {
        question: "बाबेल का अहंकार आज कैसे प्रकट होता है?",
        options: [
          "केवल प्रौद्योगिकी में",
          "परमेश्वर के बिना पूर्ण आत्मनिर्भरता की मानवीय इच्छा में",
          "ऊंची इमारतों में",
          "विभिन्न भाषाओं में"
        ],
        hint: "यह परमेश्वर के बिना जीने की इच्छा के बारे में है",
        funFact: "💭 बाबेल हमें याद दिलाता है कि परमेश्वर के बिना एकता विनाशकारी अहंकार बन जाती है!"
      }
    },

    6: {
      name: "अब्राहम का आह्वान",
      challenge: "अपने देश, अपने रिश्तेदारों और अपने पिता के घर को छोड़ दो...",
      easy: {
        question: "अब्राहम की उम्र कितनी थी जब उसने अपना देश छोड़ा?",
        options: ["50 वर्ष", "65 वर्ष", "75 वर्ष", "100 वर्ष"],
        hint: "नई शुरुआत के लिए एक बहुत बड़ी उम्र",
        funFact: "🚶 75 वर्ष की उम्र में अब्राहम एक नया जीवन शुरू करता है - कभी देर नहीं होती!"
      },
      medium: {
        question: "परमेश्वर ने अब्राहम को कौन से तीन वादे दिए?",
        options: [
          "धन, शक्ति, ज्ञान",
          "भूमि, वंश, सभी राष्ट्रों के लिए आशीर्वाद",
          "लंबा जीवन, शांति, सफलता",
          "विश्वास, आशा, प्रेम"
        ],
        hint: "एक वादा जो सभी मानवता से संबंधित है",
        funFact: "🌟 अब्राहम से किया गया वादा सभी मानवता से संबंधित है, न कि केवल उससे!"
      },
      hard: {
        question: "अब्राहम की 'विश्वास की छलांग' क्या सिखाती है?",
        options: [
          "अंधा विश्वास खतरनाक है",
          "परमेश्वर का अनुसरण करने के लिए हमारी सुरक्षा को छोड़ना आवश्यक है",
          "परमेश्वर कुछ राष्ट्रों को पसंद करता है",
          "विश्वास सफलता की गारंटी देता है"
        ],
        hint: "यह देखे बिना विश्वास करते हुए अपने संदर्भों को छोड़ने के बारे में है",
        funFact: "✨ अब्राहम को 'विश्वास का पिता' कहा जाता है क्योंकि उसने बिना देखे विश्वास किया!"
      }
    },

    7: {
      name: "इसहाक का बलिदान",
      challenge: "अपने पुत्र, अपने एकलौते, जिससे तू प्रेम रखता है...",
      easy: {
        question: "अब्राहम को इसहाक को किस पहाड़ पर बलिदान करना था?",
        options: ["सीनै", "मोरिय्याह", "कर्मेल", "सिय्योन"],
        hint: "यह पर्वत एक पवित्र स्थान बन जाएगा",
        funFact: "🏔️ मोरिय्याह पर्वत बाद में यरूशलेम के मंदिर का स्थान बनेगा!"
      },
      medium: {
        question: "परमेश्वर ने इसहाक के स्थान पर क्या प्रदान किया?",
        options: [
          "एक मेमना",
          "एक मेढ़ा जो सींगों में फंसा था",
          "एक बकरा",
          "एक बैल"
        ],
        hint: "सींगों वाला एक वयस्क नर जानवर",
        funFact: "🐏 प्रतिस्थापित मेढ़ा अंतिम प्रतिस्थापन बलिदान का पूर्वाभास है!"
      },
      hard: {
        question: "यह परीक्षा पूर्ण विश्वास को कैसे दिखाती है?",
        options: [
          "परमेश्वर क्रूरता से परीक्षा करता है",
          "विश्वास पैतृक प्रेम से भी अधिक है",
          "मानव बलिदान परमेश्वर को प्रसन्न करते हैं",
          "अब्राहम वास्तव में इसहाक से प्यार नहीं करता था"
        ],
        hint: "यह तब भी विश्वास करने के बारे में है जब हम समझ नहीं पाते",
        funFact: "💝 परमेश्वर हमेशा एक रास्ता प्रदान करता है जब हम उस पर भरोसा करते हैं!"
      }
    },

    8: {
      name: "याकूब और एसाव",
      challenge: "छोटा बड़े की सेवा करेगा...",
      easy: {
        question: "एसाव ने अपने पहलौठे के अधिकार को किसके लिए बेच दिया?",
        options: ["सोना", "दाल का एक कटोरा", "कपड़े", "दाखरस"],
        hint: "भूख मिटाने वाला भोजन",
        funFact: "🍲 भूख के एक क्षण ने एसाव को अनंत आशीर्वाद खर्च कर दिया!"
      },
      medium: {
        question: "याकूब ने अपने पिता इसहाक को कैसे धोखा दिया?",
        options: [
          "अपनी आवाज बदलकर",
          "कपड़े पहनकर",
          "बकरी की खाल से ढककर",
          "अपने नाम के बारे में झूठ बोलकर"
        ],
        hint: "अपने बालों वाले भाई की तरह दिखने के लिए",
        funFact: "🎭 इसहाक, अंधा होने के कारण, गंध और स्पर्श को पहचानता है लेकिन धोखे को नहीं!"
      },
      hard: {
        question: "यह कहानी हमारे विकल्पों के बारे में क्या प्रकट करती है?",
        options: [
          "धोखा कभी-कभी आवश्यक होता है",
          "तात्कालिक इच्छाएं हमारी नियति को खर्च कर सकती हैं",
          "परमेश्वर चालाकी को स्वीकार करता है",
          "छोटा हमेशा पसंदीदा होता है"
        ],
        hint: "यह हमारे आवेगपूर्ण निर्णयों के परिणामों के बारे में है",
        funFact: "⚖️ हमारे आवेगपूर्ण विकल्पों के अनंत परिणाम हो सकते हैं!"
      }
    },

    9: {
      name: "याकूब का स्वप्न",
      challenge: "और उसने एक सीढ़ी देखी जो पृथ्वी पर खड़ी थी, और उसका शीर्ष स्वर्ग तक पहुंचता था...",
      easy: {
        question: "याकूब ने अपने स्वप्न में क्या देखा?",
        options: [
          "एक विशाल वृक्ष",
          "स्वर्ग जाने वाली सीढ़ी और स्वर्गदूत",
          "एक मंदिर",
          "तारे"
        ],
        hint: "स्वर्ग और पृथ्वी के बीच संचार का मार्ग",
        funFact: "👼 याकूब की सीढ़ी स्वर्ग और पृथ्वी के बीच संबंध का प्रतीक है!"
      },
      medium: {
        question: "याकूब ने उस पत्थर का क्या किया जिस पर उसने सिर रखा था?",
        options: [
          "उसे तोड़ दिया",
          "उसे दफना दिया",
          "उसे खड़ा किया और तेल डाला",
          "उसे ले गया"
        ],
        hint: "एक पवित्र स्मारक बनाया",
        funFact: "🪨 यह पत्थर 'बेथेल' बन जाता है - परमेश्वर का घर!"
      },
      hard: {
        question: "यह दर्शन हमारे जीवन में स्वर्ग और पृथ्वी को कैसे जोड़ता है?",
        options: [
          "केवल स्वप्नों के माध्यम से",
          "प्रार्थना के माध्यम से जो दिव्य के साथ पुल बनाती है",
          "रक्षक स्वर्गदूतों के माध्यम से",
          "पवित्र स्थानों के माध्यम से"
        ],
        hint: "यह परमेश्वर के साथ हमारे संचार के बारे में है",
        funFact: "🌉 प्रार्थना स्वर्ग की ओर हमारी व्यक्तिगत सीढ़ी है!"
      }
    },

    10: {
      name: "यूसुफ को उसके भाइयों ने बेच दिया",
      challenge: "देखो, स्वप्न देखने वाला आ रहा है...",
      easy: {
        question: "यूसुफ के कितने भाई थे?",
        options: ["7 भाई", "10 भाई", "11 भाई", "12 भाई"],
        hint: "इस्राएल की जनजातियों की संख्या से एक कम",
        funFact: "👨‍👨‍👦‍👦 याकूब के 12 पुत्र इस्राएल की 12 जनजातियां बनेंगे!"
      },
      medium: {
        question: "यूसुफ को कितने चांदी के सिक्कों में बेचा गया?",
        options: [
          "10 चांदी",
          "20 चांदी",
          "30 चांदी",
          "50 चांदी"
        ],
        hint: "एक दास की कीमत",
        funFact: "💰 20 चांदी, उस समय एक दास की कीमत!"
      },
      hard: {
        question: "ईर्ष्या परमेश्वर की योजना का साधन कैसे बन जाती है?",
        options: [
          "परमेश्वर ईर्ष्या को स्वीकार करता है",
          "बुराई परमेश्वर द्वारा भलाई में बदल दी जाती है",
          "ईर्ष्या आवश्यक है",
          "भाई सही थे"
        ],
        hint: "यह परमेश्वर की संप्रभुता के बारे में है जो बुराई को बदल देती है",
        funFact: "🎨 परमेश्वर हमारे सबसे बुरे कार्यों को भी अपने अनुग्रह की उत्कृष्ट कृति में बदल देता है!"
      }
    },

    11: {
      name: "यूसुफ जेल में",
      challenge: "यहोवा यूसुफ के संग था और उस पर दया की...",
      easy: {
        question: "यूसुफ के पास कौन सी विशेष प्रतिभा थी?",
        options: [
          "भविष्यवाणी करना",
          "स्वप्नों की व्याख्या करना",
          "बीमारों को ठीक करना",
          "जानवरों से बात करना"
        ],
        hint: "स्वप्नों से संबंधित एक क्षमता",
        funFact: "💭 स्वप्नों को प्राचीन काल में दैवीय संदेश माना जाता था!"
      },
      medium: {
        question: "फिरौन के कौन से दो सेवक यूसुफ के साथ जेल में थे?",
        options: [
          "मंत्री और लेखक",
          "पिलानेहार और पकानेहार",
          "डॉक्टर और रक्षक",
          "रसोइया और माली"
        ],
        hint: "जो दाखरस और रोटी परोसते थे",
        funFact: "🍷 पिलानेहार राजा के लिए दाखरस चखता था ताकि जहर से बचा जा सके!"
      },
      hard: {
        question: "यूसुफ विपत्ति में विश्वासयोग्यता के बारे में क्या सिखाता है?",
        options: [
          "अन्याय स्वीकार्य है",
          "परमेश्वर के प्रति विश्वासयोग्यता परिस्थितियों से परे है",
          "जेल लोगों को बदल देती है",
          "बदला लेना आवश्यक है"
        ],
        hint: "यह परीक्षाओं में भी विश्वासयोग्य रहने के बारे में है",
        funFact: "⭐ जेल में भी, यूसुफ वफादार रहा और परमेश्वर ने उसे ऊंचा उठाया!"
      }
    },

    12: {
      name: "फिरौन के स्वप्न",
      challenge: "सात मोटी गायें... सात दुबली गायें...",
      easy: {
        question: "कितनी दुबली गायों ने मोटी गायों को खा लिया?",
        options: ["5", "6", "7", "8"],
        hint: "एक पूर्ण संख्या",
        funFact: "🐄 संख्या 7 बाइबल में पूर्णता का प्रतीक है!"
      },
      medium: {
        question: "स्वप्न में 7 वर्ष का क्या अर्थ था?",
        options: [
          "7 वर्ष युद्ध फिर शांति",
          "7 वर्ष प्रचुरता फिर 7 वर्ष अकाल",
          "7 वर्ष बीमारी फिर स्वास्थ्य",
          "7 वर्ष बारिश फिर सूखा"
        ],
        hint: "प्रचुरता और कमी का चक्र",
        funFact: "🌾 यूसुफ ने इस व्याख्या से मिस्र और अपने परिवार को बचा लिया!"
      },
      hard: {
        question: "दैवीय ज्ञान आपदाओं को कैसे बदलता है?",
        options: [
          "सभी आपदाओं से बचकर",
          "तैयारी के लिए बुद्धि प्रदान करके",
          "दुष्टों को दंडित करके",
          "विश्वासियों को समृद्ध बनाकर"
        ],
        hint: "यह तैयारी और पूर्वानुमान के बारे में है",
        funFact: "💡 दैवीय ज्ञान आपदाओं को मुक्ति के अवसरों में बदल देता है!"
      }
    },

    13: {
      name: "भाइयों का मेल-मिलाप",
      challenge: "मैं यूसुफ हूं, तुम्हारा भाई जिसे तुमने बेच दिया था...",
      easy: {
        question: "यूसुफ ने बिन्यामीन के थैले में क्या रखा?",
        options: [
          "सोना",
          "उसकी अंगूठी",
          "उसका चांदी का प्याला",
          "एक पत्र"
        ],
        hint: "एक मूल्यवान व्यक्तिगत वस्तु",
        funFact: "🏆 प्याले का उपयोग पानी में 'भविष्य पढ़ने' के लिए भी किया जाता था!"
      },
      medium: {
        question: "यूसुफ ने बुराई के बदलने के बारे में कौन सा प्रसिद्ध वाक्यांश कहा?",
        options: [
          "मैं तुम्हें क्षमा करता हूं",
          "तुमने बुराई की योजना बनाई, परमेश्वर ने इसे भलाई में बदल दिया",
          "आओ अतीत को भूल जाएं",
          "प्रतिशोध परमेश्वर का है"
        ],
        hint: "परमेश्वर की संप्रभुता के बारे में एक वाक्य",
        funFact: "✨ यह वाक्य हमारे जीवन में परमेश्वर की सारी संप्रभुता को सारांशित करता है!"
      },
      hard: {
        question: "क्षमा प्रतिशोध के चक्र को कैसे तोड़ती है?",
        options: [
          "बुराई को भूलकर",
          "अपराधी और पीड़ित दोनों को एक नई शुरुआत देकर",
          "पहले दंड देकर",
          "दूरी बनाकर"
        ],
        hint: "यह दोनों पक्षों की मुक्ति के बारे में है",
        funFact: "🕊️ यूसुफ की क्षमा दुनिया की दैवीय क्षमा का पूर्वाभास है!"
      }
    }
  }
};

export default chapter1Translations;
